import { HopperOctopusConfiguration, HopperOctopusOptions } from '../hopper';
import { AutenticacaoService } from './autenticacao.service';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OctopusConfigurationService extends HopperOctopusConfiguration {
  constructor(
    private http: HttpClient,
    private autenticacaoService: AutenticacaoService
  ) {
    super();
  }

  async initializeAsync(): Promise<void> {
    try {
      if (this.autenticacaoService.logado()) {
        this._config = await this.getConfigAsync();
      } else {
        this._config = new HopperOctopusOptions();
      }

      this._isInitialized = true;
      return Promise.resolve();
    } catch {
      this._isInitialized = false;

      return Promise.reject();
    }
  }

  async getConfigAsync(): Promise<HopperOctopusOptions> {
    return this.http
      .get<HopperOctopusOptions>(globals.apiUrl + '/api/OctopusConfiguration/Config')
      .toPromise()
      .then((data) => Promise.resolve(data))
      .catch(() => Promise.reject(new HopperOctopusOptions()));
  }

  async setConfigAsync(config: HopperOctopusOptions): Promise<void> {
    await this.http
      .post(globals.apiUrl + '/api/OctopusConfiguration/Config', config)
      .toPromise()
      .then(() => {
        this._config.apiUrl = config.apiUrl;
        this._config.clientId = config.clientId;
        return Promise.resolve();
      })
      .catch(() => Promise.reject());
  }

  getAuthToken(): string {
    const { accessToken } = this.autenticacaoService.obterToken();

    return accessToken;
  }
}
